<form name="CompanyHolidayForm" (ngSubmit)="Validate(CompanyHolidayForm)" #CompanyHolidayForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Company Holiday</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-1 pt-2">
                    <label>Year</label>
                    <select name="Year" class="form-control form-select" placeholder="year"
                        [(ngModel)]="HolidayMappingDetail.Year" #Year="ngModel"
                        (ngModelChange)="SetCalendarDate();this.GetHoliday()"
                        [ngModelOptions]="{standalone: true}" required>
                        <option [value]=null hidden disabled>Select Year</option>
                        <option *ngFor="let Year of Years" [value]="Year">
                            {{Year}}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                        Please select year !
                    </div>

                </div>
                <div class="col-md-12 px-1 pt-2">

                    <label>Holiday Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="yyyy-mm-dd" name="HolidayDate"
                            placeholder="Ex. DD/MM/YYYY" [(ngModel)]="HolidayMappingDetail.DateObj"
                            #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                            [ngModelOptions]="{standalone: true}" required
                            readonly
                            [minDate]="this.filter.CalendarMinDate"
                            [maxDate]="this.filter.CalendarMaxDate" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please enter holiday date !
                        </div>
                    </div>



                </div>
                <div class="col-md-12 px-1 pt-2">

                    <label>Holiday</label>
                    <select name="HolidayID" class="form-control form-select"
                        [(ngModel)]="HolidayMappingDetail.ESS_HolidayMasterId" #HolidayID="ngModel"
                        [ngModelOptions]="{standalone: true}" required>
                        <option [value]=null hidden disabled>Select Hoilday</option>
                        <option *ngFor="let Holiday of Holidays" [value]="Holiday.ESS_HolidayMasterID">
                            {{Holiday.HolidayName}} - {{Holiday.HolidayType}}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                        Please select holiday.
                    </div>

                </div>
            </div>

        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button type="submit"
                        *ngIf="(this.ID == 0 && this.common.PageRight.IsAdd) || (this.ID > 0 && this.common.PageRight.IsEdit)"
                        class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>

                </div>
            </div>

        </div>
    </div>
</form>